import { mapState, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState(["routeName"]),
    patientRoute() {
      return (
        this.routeName.length <= 1 ||
        this.routeName == "/add/patient" ||
        this.routeName.startsWith("/import") ||
        this.routeName.startsWith("/patient") ||
        this.routeName.startsWith("/label") ||
        this.routeName.startsWith("/filter") ||
        this.routeName.startsWith("/reachout") ||
        this.routeName.startsWith("/upcoming") ||
        this.routeName.startsWith("/tag")
      );
    },
    responseRoute() {
      return this.routeName.startsWith("/response");
    },
    eventRoute() {
      return this.routeName.startsWith("/event");
    },
    outcomeRoute() {
      return this.routeName.startsWith("/outcome");
    },
    overviewRoute() {
      return this.routeName.startsWith("/overview");
    },
    engagementRoute() {
      return this.routeName.startsWith("/engagement");
    },
    routeClass() {
      if (this.outcomeRoute) return "outcome";
      if (this.engagementRoute) return "engagement";
      return "patient";
    },
  },
};
